import { useQuery } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import {
  IGetCategoryParamsType,
  IGetCategoryResponseType,
  IPaginatedResponse
} from './type'

export function useGetCategory({
  data,
  disableToast,
  ...rest
}: IApiBaseTypes<IGetCategoryParamsType> = {}) {
  return useQuery({
    queryFn: async () =>
      await APIInstance<IPaginatedResponse<IGetCategoryResponseType>>({
        url: 'mrf/categories/',
        params: data,
        method: 'get',
        data
      }),
    queryKey: ['categoryList', data],
    retry: 0,
    select: (data) => data?.data,
    ...rest
  })
}
